const STEPS = [
  {
    title: "Personalize your menu",
    desc: "Pick your favorite meals, switch plans, pause or start whenever you like online",
    img: "/images/stepline/01.svg",
  },
  {
    title: "We cook and deliver fresh",
    desc: "From our chef kitchen to your plate. Delivered fresh right to your door",
    img: "/images/stepline/02.svg",
  },
  {
    title: "Heat & Eat in 2-3 min",
    desc: "Your delicious meals are ready-to-eat in just 2-3 minutes, with no prep required!",
    img: "/images/stepline/03.svg",
  },
  {
    title: "Enjoy & Repeat!",
    desc: "Enjoy the convenience of automatic weekly delivery. Pause or cancel any time",
    img: "/images/stepline/04.svg",
  },
];

export default STEPS;
